import React from 'react';
import styles from './AuditionsSection.module.css';
import AuditionCard from '../../../../components/common/AuditionCard/AuditionCard';
import cardStyles from '../../../../components/common/AuditionCard/AuditionCard.module.css';

/**
 * @component AuditionCardsGrid
 * @description 공고 카드 3-column 그리드 (랜딩 페이지 전용)
 */
function AuditionCardsGrid({ auditions, onCardClick }) {
  return (
    <div className={styles.auditionCardsGrid}>
      {auditions.map((audition) => (
        <AuditionCard
          key={audition.id}
          category={audition.category}
          location={audition.location}
          dDay={audition.dDay}
          isClosing={audition.isClosing}
          showRoleTags={false}
          title={audition.title}
          company={audition.company}
          role={audition.role}
          roles={audition.roles}
          onClick={() => onCardClick && onCardClick(audition.id)}
          className={cardStyles.auditionCardDark}
        />
      ))}
    </div>
  );
}

export default AuditionCardsGrid;
